export const wordsList = {
  "Membra das µ's": [
    "Honoka", "Kotori", "Umi",
    "Maki", "Rin", "Hanayo",
    "Eli", "Nico", "Nozomi"
  ],

  "Membra de Nijigasaki": [
    "Ayumu", "Kasumi", "Shizuku",
    "Karin", "Ai", "Kanata",
    "Setsuna", "Emma", "Rina",
    "Shioriko", "Mia", "Lanzhu",
    "Yuu"
  ],

  "Membra das Aqours": [
    "Chika", "Riko", "Kanan",
    "Dia", "You", "Yohane",
    "Hanamaru", "Mari", "Ruby"
  ],

  "Membra de Liella": [
    "Kanon", "Keke", "Chisato",
    "Sumire", "Ren", "Kinako",
    "Mei", "Shiki", "Natsumi",
    "Margarete", "Tomari"
  ],

  "Membra de Saint-Snow": [
    "Leah", "Sarah"
  ],

  "Membra de A-RISE": [
    "Tsubasa", "Erena", "Anju"
  ],

  "Membra de Sunny Passion": [
    "Mao", "Yuuna"
  ],

  "Melhor personagem de Love Live": ["Maki"],

  "Membra de Happy Around!": [
    "Rinku", "Maho", "Muni", "Rei"
  ],

  "Membra de Peaky P-key": [
    "Kyoko", "Shinobu", "Yuka", "Esora"
  ],

  "Membra de Photon Maiden": [
    "Saki", "Ibuki", "Towa", "Noa"
  ],

  "Membra de Merm4id": [
    "Rika", "Marika", "Saori", "Dalia"
  ],

  "Membra de RONDO": [
    "Tsubaki", "Nagisa", "Hiiro", "Aoi"
  ],

  "Membra de Lyrical Lily": [
    "Miyu", "Haruna", "Kurumi", "Miiko"
  ],

  "Membra de Call of Artemis": [
    "Airi", "Shano", "Mana", "Toka"
  ],

  "Membra de Abyssmare": [
    "Neo", "Sophia", "Elsie", "Weronika"
  ],

  "Membra de UniChØrd": [
    "Michiru", "Lumina", "Kokoa", "Hayate"
  ],

  "Membra de A Bad Cynic Doggo": [
    "Eimi", "Bell", "Shika", "Date"
  ],

  "Melhor personagem de D4DJ": ["Noa"]
};
